import '../../../styles/gradient-spinner.css';

import React from 'react';
import { Box, Image, useColorModeValue } from '@chakra-ui/react';

import boltImg from '../../../assets/images/evse_charger_loader_bolt.svg';

export const BoltLoader = () => {
  const gradientColorModeClassName = useColorModeValue('light-mode-gradient', 'dark-mode-gradient');

  return (
    <Box mt={4} position="relative">
      <Box className={`gradient-spinner ${gradientColorModeClassName}`} />
      <Image src={boltImg} alt="Charging Station Power On" position={'absolute'} right={45} top={9} />
    </Box>
  );
};
